import { connect } from 'react-redux';
import { clearLogs } from '../../actions/';
import LogsPanel from '../../components/logsPanel/LogsPanel';

const mapStateToProps = state => {
  return {
    logs: state.logs,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onClear: () => {
      dispatch(clearLogs());
    },
  };
};

const LogsPanelRedux = connect(mapStateToProps, mapDispatchToProps)(LogsPanel);

export default LogsPanelRedux;
